/* global lang */
import React from 'react';
import ReactDOM from 'react-dom';
import socket, { getQueryParams } from './socket';
import Main from './components/Main';
import ProjectStyler from './components/ProjectStyler';
import StatsDashboard from './components/StatsDashboard';
import './css/index.css';
import './css/StatsDashboard.css';

let envDevApi = '';
if(document.location.host.startsWith('chatroulette.dev')) {
  let hostArray = document.location.host.split('chatroulette.dev');
  envDevApi = `https://chatroulette-api.dev${hostArray[1]}`;
}
//envDevApi = 'https://chatroulette-api.blastream.com';
window.envDevApi = process.env.NODE_ENV==='development' ? envDevApi : '';

class EventEmitter {
  constructor() {
    this.events = {};
  }
  
  on(event, listener) {
      if (typeof this.events[event] !== 'object') {
          this.events[event] = [];
      }
      this.events[event].push(listener);
      return () => this.removeListener(event, listener);
  }
  
  removeListener(event, listener) {
    if (typeof this.events[event] === 'object') {
        let timeout = 0;
        if(this.events[event].length > 1)
          timeout = 100;
          setTimeout(() => {
          const idx = this.events[event].indexOf(listener);
          if (idx > -1) {
            this.events[event].splice(idx, 1);
          }
        }, timeout)
    }
  }
  
  emit(event, ...args) {
    if (typeof this.events[event] === 'object') {
      this.events[event].forEach(listener => listener.apply(this, args));
    }
  }
  
  once(event, listener) {
    const remove = this.on(event, (...args) => {
        remove();
        listener.apply(this, args);
    });
  }
  
};

window.appEvents = new EventEmitter();

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      client: socket(),
      showNext: true,
      u1p1: '',
      u1p2: '',
      u1p3: '',
      u2p1: '',
      u2p2: '',
      u2p3: '',
    };
  }
  
  componentDidMount() {
    window.appEvents.on('endCall', () => {
      console.log('endCall')
      this.setState({
          u1p1: '',
          u1p2: '',
          u1p3: '',
          question: '',
          showQuestion: false
        })

    });
    
    window.appEvents.on('infoUsers', (data, toId) => {
      console.log('data', data, toId)
      this.toId = toId;
      this.countQuestion = 0;
      if(data.questions) {
        this.questionLength = data.questions.length;
        this.questions = data.questions;
        this.setState({
          u1p1: data.u1p1,
          u1p2: data.u1p2,
          u1p3: data.u1p3,
          u2p1: data.u2p1,
          u2p2: data.u2p2,
          u2p3: data.u2p3,
          question: this.questions[this.countQuestion],
          showQuestion: true
        })
      }
    })
    
    window.appEvents.on('nextQuestion', () => {
      this.countQuestion++;
      this.setState({
        question: this.questions[this.countQuestion]
      });
    });
    
  }
  
  nextQuestion = () => {
    window.appEvents.emit('sendNextQuestion', this.toId);
  }
  
//https://one2one.man.invaders.stream/connect/?id1=1&id2=2&time=30&u1p1=test&u1p2=test2&u1p3=test3&u2p1=ee&u2p2=rr&u2p3=dddd&questions[]=%C3%A7a%20va%20?&questions[]=h%C3%A9h%C3%A9%20bien%20
  
  render() {
    return (
      <div className={"root " + codelang}>
        <ProjectStyler />
        <div className="header">
          {/*<div className={'info m'}>
            <p className={'p1'}>{ this.state.u1p1 }</p>
            <p className={'p2'}>{ this.state.u1p2 }</p>
            <p className={'p3'}>{ this.state.u1p3 }</p>
          </div>
          <div className={'info m'}>

          </div>
          <div className={'info c'}>
            <p className={'p1'}>{ this.state.u2p1 }</p>
            <p className={'p2'}>{ this.state.u2p2 }</p>
            <p className={'p3'}>{ this.state.u2p3 }</p>
    </div>*/}
        </div>
        <Main client={this.state.client} />
        <div className="footer">
          { this.state.showQuestion &&
            <div className="questions">  
              {/*<p>{ lang.answer_question }</p>*/}
              <div className="question">
                { this.state.question }
              </div>
              { this.countQuestion < (this.questionLength-1) &&
                <button className="btn btn-question" onClick={ this.nextQuestion }>{ lang.next }</button>
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

var url = new URL(window.location.href);

var layout = url.searchParams.get("layout");

if (layout) {
  var link = document.createElement("link");
  link.href = layout;
  link.type = "text/css";
  link.rel = "stylesheet";
  link.media = "screen,print";

  document.getElementsByTagName("head")[0].appendChild(link);
}

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// Initialize window.lang - will be populated when projectConfig is received
window.lang = {};

var codelang = url.searchParams.get("codelang");

// Check for stats mode and render appropriate component
const urlParams = getQueryParams(document.location.search);

if (urlParams.action === 'stats') {
  // Stats mode - render StatsDashboard
  try {
    const client = socket();
    if (client.isStatsMode) {
      ReactDOM.render(
        <StatsDashboard socket={client.socket} roomId={client.roomId} />,
        document.getElementById('root')
      );
    }
  } catch (err) {
    console.error('Failed to initialize stats mode:', err);
  }
} else {
  // Normal mode - render the app
  ReactDOM.render(<App />, document.getElementById('root'));
}

